import * as Yup from 'yup';

const schema = Yup.object().shape({
  tipo: Yup.string().required('Valor requerido'),
  legislacao: Yup.string().required('Valor requerido')
});

export default schema;
